import { Expose } from 'class-transformer';

export class ViewVariantProductOptionDto {
  @Expose() id: string;
  @Expose() name: string;
}
